import { render, staticRenderFns } from "./JumpNaviWithAuthorQuoteForm.vue?vue&type=template&id=b87565e8&"
import script from "./JumpNaviWithAuthorQuoteForm.vue?vue&type=script&lang=js&"
export * from "./JumpNaviWithAuthorQuoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports